<template>
  <div class="menuBg">
    <div
      :style="{
        position: 'fixed',
        top: item.y + 'px',
        left: item.x + 'px',
        width: item.w + 'px',
        height: item.h + 'px'
      }"
      class="animation"
      v-for="item in animations"
      :key="item.uid"
    >
      <img style="width: 100%;" :src="item.img" />
    </div>
    <div class="main-menu">
      <header-menu ref="headerMenu" />
      <custom-home-button
        v-if="showCustomHomeButton"
        @onShowCustomHome="doShowCustomHome"
        :active="!customHomeActive"
      />
      <div class="tabs-wrapper container">
        <slider-tabs
          @onCategoryChange="onCategoryChange"
          :highlightEnabled="sliderHighlightEnabled"
        />
        <custom-home
          v-if="customHomeActive"
          ref="customHome"
          @onAddBasket="addBasketHandler"
          @onGoPromo="goPromoCustomHome"
          @onConfirmProductAttributes="onConfirmProductAttributes"
        />
        <product-list
          v-if="!customHomeActive"
          ref="productList"
          class="product_list main_menu_product_list"
          :itemIds="itemIds"
          :current-category="currentCategory"
          :big="true"
          :bigItem="true"
          :noprices="project === 'elite'"
          @onAddBasket="addBasketHandler"
          @onCloseIngredientWizard="onCloseIngredientWizard"
          @onConfirmProductAttributes="onConfirmProductAttributes"
        />
      </div>
      <div>
        <div class="video-clickable-sm" @click="goPromo">
          <video-bg
            :bg-opacity="0.6"
            bg-color="#000"
            @ended="onPromoVideoEnded()"
            :src="currentPromo.video"
            ref="video"
          >
          </video-bg>
        </div>
        <bottom-nav
          :noprices="project === 'elite'"
          :show-total-container="true"
          :show-scan-and-go="false"
          :show-submit="true"
          @proceed="goToOrder"
          @goOrder="goToOrder"
          >{{ $t("menu.footer.complete_order") }}
        </bottom-nav>
      </div>
    </div>
  </div>
</template>
<script>
import SliderTabs from "@/components/menu/SliderTabs.vue";
import ProductList from "@/components/menu/ProductList.vue";
import BottomNav from "@/components/BottomNav.vue";
import HeaderMenu from "@/components/menu/HeaderMenu.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  generate_random_string,
  getPotentialMenus,
  shuffleArray,
  transitionAnimation
} from "@/utils/helpers";

import { totalPrice } from "@/utils/pricing";
import { checkSchedules } from "@/utils/schedules";
import {
  addProductToBasket,
  combineProductsToMenu,
  getProductPosition,
  productToBasketItem
} from "@/utils/products";

import { cloneDeep, isEmpty, isEqual } from "lodash";
import CustomHomeButton from "@/components/menu/CustomHomeButton.vue";
import CustomHome from "@/components/menu/CustomHome.vue";
import { isCustomHomeEnabled, isV2SelectMenu } from "@/utils/templateSettings";

export default {
  components: {
    CustomHome,
    CustomHomeButton,
    SliderTabs,
    BottomNav,
    ProductList,
    HeaderMenu
  },
  data() {
    return {
      sliderHighlightEnabled: true,
      currentPromoIndex: 0,
      activePromos: [],
      animations: [],
      animateShowSelectMenuModal: true
    };
  },
  computed: {
    ...mapGetters({
      activeCombo: "ACTIVE_COMBO",
      customHomeSetting: "CUSTOM_HOME_SETTING",
      customHomeActive: "CUSTOM_HOME_ACTIVE",
      delivery_method_full: "DELIVERY_METHOD_FULL",
      delivery_method: "SELECTED_DELIVERY_METHOD",
      categories: "CATEGORIES_FILTERED",
      productsList: "PRODUCTS_FILTERED_BY_CATEGORY",
      allProducts: "PRODUCTS",
      promos: "PROMOS",
      menus: "MENUS",
      currentCategory: "CURRENT_CATEGORY",
      basket: "BASKET",
      project: "PROJECT",
      schedules: "SCHEDULES"
    }),
    itemIds() {
      return this.productsList.map(item => item.id);
    },
    menusList() {
      return this.menus.filter(item => checkSchedules(this.schedules, item));
    },
    sumPrice() {
      return totalPrice(this.basket);
    },
    defaultTab() {
      if (
        typeof this.currentCategory !== "undefined" &&
        this.currentCategory !== null &&
        this.currentCategory.id
      ) {
        return this.currentCategory.id;
      }
      if (this.categories.length > 0) {
        return this.categories[0].id;
      }
      return 0;
    },
    basketCount() {
      let sum = 0;
      this.basket.forEach(item => {
        sum += item.count;
      });
      return sum;
    },
    currentPromo() {
      if (this.activePromos.length > 0 && this.currentPromoIndex >= 0) {
        return this.activePromos[this.currentPromoIndex];
      }
      return { video: "" };
    },
    showCustomHomeButton() {
      return isCustomHomeEnabled();
    }
  },
  created() {
    this.init();
  },
  methods: {
    onCategoryChange(id, event) {
      console.log("onCategoryChange event " + event);
      if (isCustomHomeEnabled()) {
        if (event) {
          // only set current category on click event
          this.setCurrentCategory(id);
        }
      } else {
        this.setCurrentCategory(id);
      }
      this.doHideCustomHome();
    },
    doShowCustomHome() {
      console.log("doShowCustomHome");
      this.setCustomHomeActive(true);
      this.sliderHighlightEnabled = false;
    },
    doHideCustomHome() {
      console.log("doHideCustomHome");
      this.setCustomHomeActive(false);
      this.sliderHighlightEnabled = true;
    },
    init() {
      console.log("init");
      this.setPolelight("blue");
      if (
        typeof this.delivery_method_full === "undefined" ||
        this.delivery_method === null
      ) {
        console.log("init: logRouter home");
        this.logRouter({ name: "home", router: this.$router });
        return;
      } else if (this.delivery_method_full.identifier === "scan") {
        this.logRouter({ name: "order", router: this.$router });
        return;
      }
      this.setCurrentCategory(this.defaultTab);
      this.setupPromos();
      if (this.customHomeActive) {
        this.doShowCustomHome();
      } else {
        this.doHideCustomHome();
      }
    },
    onPromoVideoEnded() {
      console.log("onPromoVideoEnded");
      let old_video = this.currentPromo.video;
      if (this.activePromos.length > 0) {
        this.currentPromoIndex =
          (this.currentPromoIndex + 1) % this.activePromos.length;
      }
      if (this.currentPromo.video === old_video) {
        //same video just hit play again!
        this.$refs.video.play();
      }
    },
    setupPromos() {
      this.activePromos = this.promos.filter(
        item => !item.hide && checkSchedules(this.schedules, item)
      );
      this.activePromos = shuffleArray(this.activePromos);
      this.currentPromoIndex = 0;
    },
    goPromo() {
      if (!this.currentPromo || !this.currentPromo.product) return;
      const product = this.allProducts.find(
        elem => elem.id === this.currentPromo.product
      );
      const basketItem = productToBasketItem(product);
      basketItem.promo = this.currentPromo;
      if (this.customHomeActive) {
        console.log("goPromo customHomeActive");
        this.$refs.customHome.$refs.topProducts.prepareItem(basketItem);
      } else {
        this.$refs.productList.prepareItem(basketItem);
      }
    },
    goPromoCustomHome(product) {
      console.log("goPromoCustomHome");
      const basketItem = productToBasketItem(product);
      this.$refs.customHome.$refs.topProducts.prepareItem(basketItem);
    },
    onCloseIngredientWizard() {
      console.log("onCloseIngredientWizard");
      if (this.customHomeActive) {
        this.doShowCustomHome();
      } else {
        this.doHideCustomHome();
      }
    },
    onConfirmProductAttributes() {
      console.log("onConfirmProductAttributes");
      this.animateShowSelectMenuModal = false;
    },
    addToBasketOnly(product, basketItem) {
      console.log("addToBasketOnly");
      let newBasket = addProductToBasket(basketItem, this.basket);
      newBasket = combineProductsToMenu(this.menus, newBasket);
      this.setBasket(newBasket);
      this.logAudit({
        category: "CART",
        event: "ADD_PRODUCT",
        data: product
      });
    },
    offerMenu(product) {
      const basketItem = productToBasketItem(product);

      const potential_menus = getPotentialMenus(
        this.menusList,
        product.menus,
        false
      );
      if (potential_menus.length > 0) {
        const menu = cloneDeep(potential_menus[0]);
        if (
          menu.components[0].available_products.find(
            p => p.id === basketItem.id
          )
        ) {
          //prepopulate first product
          menu.components[0].selected = basketItem;
        }
        menu.uid = generate_random_string(16);
        menu.needAsk = true;
        if (!menu.ask_for_menu) {
          menu.selectedCombo = true;
          //menu.id = `combo_${parseInt(Math.random() * 1000)}`;
          //menu.productId = menu.id;
        }
        this.setActiveCombo(menu);
        if (isV2SelectMenu() && menu.ask_for_menu) {
          this.showSelectMenuModal();
        } else {
          if (this.$refs.headerMenu.$refs.yellowCircle) {
            this.yellowCircleAnimation(!menu.selectedCombo, () => {
              this.logRouter({ name: "combo", router: this.$router });
            });
          } else {
            this.logRouter({ name: "combo", router: this.$router });
          }
        }
        return true;
      }
      return false;
    },
    showSelectMenuModal() {
      if (this.customHomeActive) {
        this.$refs.customHome.$refs.topProducts.showSelectMenuModal(
          this.activeCombo,
          this.animateShowSelectMenuModal
        );
      } else {
        this.$refs.productList.showSelectMenuModal(
          this.activeCombo,
          this.animateShowSelectMenuModal
        );
      }
      this.animateShowSelectMenuModal = true;
    },
    addBasketHandler(product) {
      let do_offer_menu = true;
      let force_navigate_away = false;
      if (typeof product.promo !== "undefined") {
        if (product.promo.only_product) {
          do_offer_menu = false;
        }
        force_navigate_away = true;
      }
      const basketItem = productToBasketItem(product);
      if (do_offer_menu && this.offerMenu(product)) {
        return true;
      }
      this.addToBasketOnly(product, basketItem);
      if (
        (isEqual(basketItem.ingredients, { default: [] }) ||
          isEmpty(basketItem.ingredients)) &&
        basketItem.extras.length === 0 &&
        !basketItem.selectedSize &&
        !force_navigate_away
      ) {
        // check if product is simple, if yes just add it to basket without going to order overview
        this.productToBasketAnimation(product);
        return false;
      }
      this.logRouter({ name: "order", router: this.$router });
      return true;
    },
    productToBasketAnimation(product) {
      let position = getProductPosition(product);
      if (!position) return;
      let animation_uid = generate_random_string(12);
      let animation_item = {
        uid: animation_uid,
        img: product.image,
        x: position.left,
        y: position.top,
        w: position.width,
        h: position.height
      };
      this.animations.push(animation_item);
      setTimeout(() => {
        this.animations = this.animations.filter(
          elem => elem.uid !== animation_uid
        );
      }, 980);
    },
    yellowCircleAnimation(ask, cb) {
      const data_ask = {
        start: {
          height: 629,
          width: 652,
          top: -332,
          left: 463
        },
        end: {
          height: 1153,
          width: 1199,
          left: -59,
          top: -466
        },
        move: {
          height: 10,
          width: 10,
          left: -10,
          top: -10
        },
        condition: {
          steps: 550,
          step: 10,
          speed: 1,
          zIndex: 100
        }
      };
      const data_no_ask = {
        start: {
          height: 629,
          width: 652,
          top: -332,
          left: 463
        },
        end: {
          height: 919,
          width: 955,
          left: 63,
          top: -420
        },
        move: {
          height: 10,
          width: 10,
          left: -15,
          top: -5
        },
        condition: {
          steps: 550,
          step: 10,
          speed: 1,
          zIndex: 100
        }
      };
      transitionAnimation("yellowCircle", ask ? data_ask : data_no_ask, cb);
    },
    clearBasket: function() {
      this.clearBasketMut();
    },
    goToOrder() {
      if (this.basket.length !== 0) {
        this.logRouter({ name: "order", router: this.$router });
      }
    },
    ...mapMutations({
      setCustomHomeActive: "SET_CUSTOM_HOME_ACTIVE",
      setLayoutSetting: "SET_TEMPLATE_SETTING",
      setCurrentCategory: "SET_CURRENT_CATEGORY",
      setProducts: "SET_PRODUCTS",
      setBasket: "SET_BASKET",
      setActiveCombo: "SET_ACTIVE_COMBO",
      clearBasketMut: "CLEAR_BASKET"
    }),
    ...mapActions({
      getCategories: "GET_CATEGORIES",
      getProducts: "GET_PRODUCTS",
      getProductFilters: "GET_PRODUCT_FILTERS",
      getMenus: "GET_MENUS",
      getPromos: "GET_PROMOS",
      getSchedule: "GET_SCHEDULE",
      getOffers: "GET_OFFERS",
      logRouter: "LOG_ROUTER",
      logAudit: "LOG_AUDIT",
      setPolelight: "SET_POLELIGHT"
    })
  }
};
</script>
<style lang="scss" scoped>
@keyframes addToBasketAnim {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  80% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.4;
    width: 100px;
    height: 100px;
    top: 1760px;
    left: 750px;
  }
}

.animation {
  animation: addToBasketAnim 1s ease;
  z-index: 1500;
  pointer-events: none;
}

.menuBg {
  background: var(--page_menu_menuBg_background);
}

.filler {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs-wrapper {
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  z-index: 5;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 30px 20px 20px;
}
</style>
